import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("mousemove", this.handleMouseMove.bind(this))
  }

  handleMouseMove(e) {
    const rect = this.element.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    
    this.element.style.setProperty("--x", `${x}px`)
    this.element.style.setProperty("--y", `${y}px`)
  }
}
